
import Vue from 'vue'

export default Vue.extend({
  name: 'yubikeyConnectionPopupChunk',
  props: {
    parentLetRetry: {
      type: Boolean,
      required: false,
      default: false
    },
    showBackButton: {
      type: Boolean,
      required: false,
      default: false
    },
    slotData: {
      type: Object,
      required: false,
      default: () => ({
        additionalPopupContent: ''
      })
    }
  },
  data: () => ({
    letRetry: false
  }),
  methods: {
    startTimer (): void {
      const vm = this as any
      vm.letRetry = false
      setTimeout(() => {
        vm.letRetry = true
      }, 30000)
    }
  },
  mounted (): void {
    const vm = this as any
    vm.startTimer()
  }
})
